import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { 
  REWARDSTORE, 
  MEMBERSTORE, 
  MARKETPLACESTORE, 
  ENROLLMENTSTORE, 
  MAINSTORE, 
  AUTOSHIPSTORE,
  CORPORATESTOREID, 
  RETAILSTOREID, 
  IBOSTOREID, 
  AUTOSHIPSTOREID,
  updateStoreConstants,
  StoreData
} from 'src/app/constant';

export interface StoreConstants {
  REWARDSTORE: string;
  MEMBERSTORE: string;
  MARKETPLACESTORE: string;
  ENROLLMENTSTORE: string;
  MAINSTORE: string;
  AUTOSHIPSTORE: string;
  CORPORATESTOREID: string;
  RETAILSTOREID: string;
  IBOSTOREID: string;
  AUTOSHIPSTOREID: string;
}

@Injectable({
  providedIn: 'root'
})
export class StoreConstantsService {
  private storeConstantsSubject = new BehaviorSubject<StoreConstants>({
    REWARDSTORE,
    MEMBERSTORE,
    MARKETPLACESTORE,
    ENROLLMENTSTORE,
    MAINSTORE,
    AUTOSHIPSTORE,
    CORPORATESTOREID,
    RETAILSTOREID,
    IBOSTOREID,
    AUTOSHIPSTOREID
  });

  public storeConstants$: Observable<StoreConstants> = this.storeConstantsSubject.asObservable();

  /**
   * Update store constants from API response and notify subscribers
   */
  updateStoreConstants(stores: StoreData[]): void {
    // Update the global constants
    updateStoreConstants(stores);
    
    // Get current values and notify subscribers
    const currentConstants: StoreConstants = {
      REWARDSTORE,
      MEMBERSTORE,
      MARKETPLACESTORE,
      ENROLLMENTSTORE,
      MAINSTORE,
      AUTOSHIPSTORE,
      CORPORATESTOREID,
      RETAILSTOREID,
      IBOSTOREID,
      AUTOSHIPSTOREID
    };
    
    this.storeConstantsSubject.next(currentConstants);
  }

  /**
   * Get current store constants synchronously
   */
  getCurrentStoreConstants(): StoreConstants {
    return this.storeConstantsSubject.value;
  }

  /**
   * Get a specific store constant by name
   */
  getStoreConstant(constantName: keyof StoreConstants): string {
    return this.storeConstantsSubject.value[constantName];
  }
}
